import { Injectable } from '@angular/core';

import { IPersonSearchBody, IPersonSearchResultRecord } from '@assess/shared/data-mart-search';

import { SearchService } from './search.service';

@Injectable({ providedIn: 'root' })
export class PersonSearchService {
  private readonly resourceType = 'person';

  constructor(private readonly searchService: SearchService) {}

  search(body: Partial<IPersonSearchBody>) {
    return this.searchService.searchHttpGet<IPersonSearchResultRecord>(this.resourceType, body);
  }
}
